import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToAnchor 組件
 * 處理頁內錨點導航的平滑滾動
 */
const ScrollToAnchor = () => {
  const location = useLocation();
  const lastHash = useRef('');

  // 使用 useEffect 監聽 location 變化
  useEffect(() => {
    // 如果沒有 hash，則不處理
    if (location.hash) {
      // 保存當前 hash 以避免重複處理
      lastHash.current = location.hash;
      
      // 找到對應的錨點元素
      const element = document.querySelector(location.hash);
      if (element) {
        // 等待 DOM 更新後滾動到錨點位置
        // 添加小延遲以確保滾動效果正常工作
        setTimeout(() => {
          // 考慮固定導航欄的高度 (76px)
          const yOffset = -80; // 可以根據需要調整
          const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          
          // 平滑滾動到對應位置
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return null; // 這個組件不渲染任何 UI
};

export default ScrollToAnchor; 